<template>
  <v-layout justify-center>
    <div v-if="isCommChair">
      <v-layout>
        <v-flex xm12 sm4 class="title text-xs-center text-sm-left align-center">
          <v-select
            :items="searchSelect"
            v-model="searchType"
            label="Year"
            outline
            @change="searchYear"
          ></v-select>
        </v-flex>
        <v-flex xm12 md4 class="text-sm-center">
          <span class="headline">BSD</span><br />
          <span class="subheading"><i>{{ currentYear }}</i></span>
        </v-flex>
        <v-flex xm12 sm4 class="title text-sm-right">
          <v-tooltip bottom>
            <v-btn v-if="isCommChair || isAdmin" fab outline small color="primary" slot="activator" @click="onLiability()">
              <v-icon>arrow_downward</v-icon>
            </v-btn>
            <span>Download Waivers</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-btn fab outline small color="primary" @click="buildEmail()" slot="activator" :disabled="!selected">
              <v-icon dark>email</v-icon>
            </v-btn>
            <span>Email Selected</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-btn v-if="isCommChair || isAdmin" fab outline small color="primary" slot="activator" @click="onExport()" :disabled="!selected">
              <v-icon>cloud_download</v-icon>
            </v-btn>
            <span>Download Selected</span>
          </v-tooltip>
        </v-flex>
      </v-layout>

      <vue-good-table
        ref="my-table"
        styleClass="vgt-table striped bordered"
        :max-height=this.height
        :fixed-header="true"
        :isLoading=this.isTableLoading
        :columns="columns"
        :rows="rows"
        :select-options="{
          enabled: true,
          selectOnCheckboxOnly: true
        }"
        :search-options="{
          enabled: true
        }">
        <template slot="loadingContent">
          <div>
            <v-progress-circular
              :size="50"
              :width="7"
              color="blue"
              indeterminate
            ></v-progress-circular>
          </div>
        </template>
        <div slot="table-actions-bottom">
          <span class="body-2" style="padding-left: 20px;">Number of records: {{ totalCount }}</span>
        </div>
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'address'">
            <v-layout align-center justify-start row fill-height>
              <v-flex xs12>
                {{ props.row.address }}<br />{{ props.row.city }} {{ props.row.state }}, {{ props.row.zip }}
              </v-flex>
            </v-layout>
          </span>
          <span v-else-if="props.column.field == 'email'">
            <v-layout align-center justify-start row fill-height>
              <v-flex xs12>
                <a :href="'mailto:' + props.row.email" style="text-decoration: none;">
                  {{ props.row.email }}
                </a>
              </v-flex>
            </v-layout>
          </span>
          <span v-else-if="props.column.field == 'night'">
            <v-layout align-center justify-start row fill-height>
              <v-flex xs12>
                {{ props.row.night }}<br />
                {{ props.row.sheep }}
              </v-flex>
            </v-layout>
          </span>
          <span v-else-if="props.column.field == 'actions'">
            <div class="text-xs-center">
              <v-avatar
                v-if="isAdmin"
                color="blue lighten-4"
                class="mr-2 mt-2"
                size="30"
                style="cursor: pointer;"
                @click="editItem(props)"
              >
                <v-icon small>edit</v-icon>
              </v-avatar>
            </div>
          </span>
          <span v-else>
            {{props.formattedRow[props.column.field]}}
          </span>
        </template>
      </vue-good-table>

      <v-btn
        fab
        bottom
        right
        color="blue"
        dark
        fixed
        class="add-button-bottom"
        @click="showEvalForm = !showEvalForm"
      >
        <v-icon>add</v-icon>
      </v-btn>

      <EmailForm
        :visible="showEmailForm"
        :items="emailList"
        :selectedItems="emails"
        @close="closeThis"
      />

      <InternalForm
        :visible="showEvalForm"
        :item="evalItem"
        :dates="dates"
        :key="evalItem.id"
        persistent
        @close="closeThisEval"
      />

      <v-dialog
        v-model="showSelect"
        max-width="390"
      >
        <v-card>
          <v-toolbar card dark color="primary">
            <v-btn icon dark @click.stop="showSelect = false">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Select Riders</v-toolbar-title>
          </v-toolbar>

          <v-card-text>
            <v-text-field
              v-model="noRiders"
              @keyup.enter="saveSelect"
              label="Number of riders to select"
              required
            ></v-text-field>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="green darken-1"
              flat="flat"
              @click="saveSelect"
            >
              Select Riders
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-snackbar
        v-model="snackbar.show"
        :color="snackbar.color"
        :multi-line=true
        :timeout="6000"
      >
        {{ snackbar.message }}
        <v-btn
          dark
          flat
          @click="snackbar.show = false"
        >
          Close
        </v-btn>
      </v-snackbar>
    </div>
    <div v-else>You Do not have access to this!</div>
  </v-layout>
</template>

<script>
import Api from '@/services/Api'
import { VueGoodTable } from 'vue-good-table'
import 'vue-good-table/dist/vue-good-table.css'
import EmailForm from '../forms/EmailForm'
import InternalForm from './InternalForm.vue'
import moment from 'moment'
import XLSX from 'xlsx'
import _ from 'lodash'

export default {
  components: {
    VueGoodTable,
    EmailForm,
    InternalForm
  },
  data () {
    return {
      myId: this.$store.state.user.id,
      searchSelect: [],
      searchType: '',
      currentYear: 0,
      isAdmin: this.$store.state.isAdmin,
      isCommChair: false,
      dialog: false,
      loading: false,
      isTableLoading: false,
      isMounted: false,
      dates: [],
      statuses: ['Pending', 'Active'],
      status: 'Active',
      toggle_multiple: ['chair', 'assist', 'excel'],
      snackbar: {
        show: false,
        color: '',
        message: ''
      },
      editedIndex: -1,
      height: 0,
      columns: [
        {
          label: 'Company',
          field: 'company',
          thClass: 'text-center',
          type: 'text'
        },
        {
          label: 'Contact',
          field: 'contact',
          thClass: 'hidden-sm-and-down text-center',
          tdClass: 'hidden-sm-and-down',
          type: 'text'
        },
        {
          label: 'Phone',
          field: 'phone',
          thClass: 'hidden-sm-and-down text-center',
          tdClass: 'hidden-sm-and-down',
          type: 'text'
        },
        {
          label: 'Address',
          field: 'address',
          thClass: 'hidden-sm-and-down text-center',
          tdClass: 'hidden-sm-and-down',
          type: 'text'
        },
        {
          label: 'Contestants',
          field: 'contestants',
          thClass: 'hidden-sm-and-down text-center',
          tdClass: 'hidden-sm-and-down',
          type: 'text'
        },
        {
          label: 'Paid',
          field: 'paid',
          thClass: 'hidden-sm-and-down text-center',
          tdClass: 'hidden-sm-and-down',
          html: true
        },
        {
          label: 'Preference',
          field: 'prefNight1',
          thClass: 'hidden-sm-and-down text-center',
          tdClass: 'hidden-sm-and-down',
          type: 'text'
        },
        {
          label: 'Night',
          field: 'night',
          thClass: 'hidden-sm-and-down text-center',
          tdClass: 'hidden-sm-and-down',
          type: 'text'
        },
        {
          label: 'Edit',
          field: 'actions',
          thClass: 'text-center',
          tdClass: 'text-center',
          sortable: false,
          hidden: false,
          html: true,
          width: '60px'
        }
      ],
      committeeHeader: {},
      rows: [],
      active: [],
      waitList: [],
      noRiders: 0,
      randomDraw: [],
      evalItem: {},
      liason: {},
      showEmailForm: false,
      showEvalForm: false,
      showSelect: false,
      emails: [],
      payEmails: [],
      cc: [],
      bcc: [],
      emailList: [],
      ccList: [],
      bccList: [],
      emailText: '',
      haveSettings: false,
      settings: {}
    }
  },

  created () {
    this.currentYear = this.$store.state.currentYear
    this.searchType = this.$store.state.currentYear
    this.yearList()

    this.isCommChair = false
    this.isTableLoading = true

    if (this.$route.params.currentYear) {
      this.currentYear = this.$route.params.currentYear
    } else {
      this.currentYear = this.$store.state.currentYear
    }

    this.loading = true

    window.addEventListener('resize', this.handleResize)
    this.handleResize()

    this.getMembers()
    this.getSettings()
    this.getTeams()

    this.loading = false
    // console.log(this.$refs)
  },

  mounted () {
    this.isMounted = true
  },

  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
    },

    selected () {
      if (!this.isMounted) {
        return
      }

      return this.$refs['my-table'].selectedRowCount > 0
    },

    totalCount () {
      if (!this.isMounted) {
        return
      }

      return this.$refs['my-table'].totalRowCount
    }
  },

  watch: {
    '$route.params.committee': function (committee) {
      this.isTableLoading = true
      this.loading = true

      this.getSettings()
      this.getTeams()
      this.loading = false
    }
  },

  methods: {
    yearList () {
      for (let i = this.$store.state.currentYear; i >= 2013; i--) {
        this.searchSelect.push(i)
      }
    },

    async getMembers () {
      try {
        this.isCommChair = this.isAdmin
        let item = {}
        let control = {}

        const controls = this.$store.state.controls
        console.log(controls)
        control = controls.find(item => item === 'BSD')

        if (control) {
          this.isCommChair = true
        } else {
          const response = await Api().get('get_committee_by_code/BSD/' + this.currentYear)
          this.memberList = response.data.committee.Users
          this.memberList.unshift({id: 0, fullName: 'None'})

          item = this.memberList.find(item => item.id === this.myId)

          if (item.UserCommittee.title === 'Chair' || item.UserCommittee.title === 'Assist Chair') {
            this.isCommChair = true
          }
        }
        this.isTableLoading = false
      } catch (error) {
        this.error = error.response.data.error
      }
    },

    handleResize () {
      const height = window.innerHeight - 300
      this.height = height + 'px'
    },

    selectRiders () {
      this.showSelect = true
    },

    editItem (props) {
      this.evalItem = props.row

      this.showEvalForm = true
    },

    async getSettings () {
      try {
        if (this.currentYear < 2023) {
          console.group('test')
          this.settings.draw = 1
          this.haveSettings = false
        } else {
          const response = await Api().get('get_buster_settings/' + this.currentYear)
          const settings = response.data[0]

          const startDate = settings.startDate.split('-')
          const endDate = settings.endDate.split('-')
          let startDay = Number(startDate[2])
          let endDay = Number(endDate[2])

          let date = ''

          while (startDay <= endDay) {
            date = startDate[1] + '/' + startDay + '/' + startDate[0]
            console.log(date)
            this.dates.push(date)
            startDay++
          }

          this.settings.draw = 1
          this.haveSettings = true
          if (settings) {
            this.settings = settings
          }
        }

        this.isTableLoading = false
      } catch (error) {
        this.error = error.response.data.error
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async getTeams () {
      try {
        const response = await Api().get('get_teams/' + this.currentYear)

        const teamList = response.data

        const teams = []

        for (let i in teamList) {
          // teamList[i].paid = ''

          // if (teamList[i].cardNumber) {
          //   teamList[i].paid = 'Paid'
          // }

          if (teamList[i].prefNight1) {
            teamList[i].prefNight1 = moment(String(teamList[i].prefNight1)).format('MM/DD/YYYY')
          }

          if (teamList[i].night) {
            teamList[i].night = moment(String(teamList[i].night)).format('MM/DD/YYYY')
          }

          teamList[i].paid = '$' + teamList[i].amount.toLocaleString('en-US', {style: 'currency', currency: 'USD'})
          teamList[i].contestants = teamList[i].repOneName + ' - ' + teamList[i].repTwoName
          // teams.push(teamList)

          teams.push(teamList[i])
        }

        this.rows = teams

        this.isTableLoading = false
      } catch (error) {
        this.error = error.response.data.error
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async saveSelect () {
      try {
        this.isTableLoading = true
        this.showSelect = false

        var drawList = this.rows.map(obj => ({ ...obj }))
        // console.log(drawList, this.noRiders)

        if (drawList.length < this.noRiders) {
          this.snackbar.message = 'There are more draws then there are riders!'
          this.snackbar.color = 'error'
          this.snackbar.show = true
          return
        }

        this.randomDraw = []
        var random = []

        for (var i = 0; i < this.noRiders; i++) {
          var shuffled = drawList[Math.floor(Math.random() * drawList.length)]

          shuffled.status = 'Active'
          random.push(shuffled)

          _.remove(drawList, function (e) {
            return e.id === shuffled.id
          })
        }

        const response = await Api().put('activate_busters', random)
        console.log(response.data.busters)

        this.getSettings()
        this.getTeams()
        this.isTableLoading = false

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.error = error.response.data.error
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    searchYear () {
      this.currentYear = this.searchType
      this.getSettings()
      this.getTeams()
    },

    async buildPdf (itemId) {
      try {
        const response = await Api().delete('animals/' + itemId)
        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    buildEmail () {
      for (let i in this.rows) {
        this.emailList[i] = this.rows[i].contact + ' <' + this.rows[i].email + '>'
      }
      this.ccList = this.emailList
      this.bccList = this.emailList

      for (let i in this.$refs['my-table'].selectedRows) {
        this.emails[i] = this.$refs['my-table'].selectedRows[i].contact + ' <' + this.$refs['my-table'].selectedRows[i].email + '>'
      }

      this.showEmailForm = true

      if (this.emails.length > 9) {
        this.emailText = 'You are sending to ' + this.emails.length + ' email addresses'
        this.editTo = false
      } else {
        this.emailText = ''
        this.editTo = true
      }
    },

    async emailRiders () {
      for (let i in this.rows) {
        this.emailList[i] = this.rows[i].name + ' <' + this.rows[i].email + '>'
      }

      for (let i in this.$refs['my-table'].selectedRows) {
        this.payEmails[i] = this.$refs['my-table'].selectedRows[i]
      }

      console.log(this.payEmails)

      try {
        const response = await Api().post('email_riders/', this.payEmails)

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    onExport () {
      this.printMembers = this.rows.map(a => ({
        'Name': a.name,
        'Address': a.address,
        'City': a.city,
        'State': a.state,
        'Zip': a.zip,
        'Primary Phone': a.cellPhone,
        'Secondayr Phone': a.homePhone,
        'Email': a.email,
        'Age': a.age,
        'Birthday': a.birthDate,
        'Weight': a.weight,
        'Parents': a.parents,
        'Status': a.status,
        'Night': a.night,
        'Sheep': a.sheep,
        'Notes': a.notes
      }))

      let membersWS = XLSX.utils.json_to_sheet(this.printMembers)

      let wb = XLSX.utils.book_new()

      if (!wb.Props) { wb.Props = {} }
      wb.Props.Title = 'Mutton Bustin'

      XLSX.utils.book_append_sheet(wb, membersWS, this.committeeHeader.committeeCode)

      XLSX.writeFile(wb, this.currentYear + ' Mutton Busters.xlsx')
    },

    async onLiability () {
      try {
        const response = await Api().get('get_liability/' + this.currentYear)

        console.log(response.data)

        const liabilities = response.data

        const Liabilities = liabilities.map(a => ({
          'First Name': a.firstName,
          'Last Name': a.lastName,
          'Type': a.type,
          'Date': a.date
        }))

        let membersWS = XLSX.utils.json_to_sheet(Liabilities)

        let wb = XLSX.utils.book_new()

        if (!wb.Props) { wb.Props = {} }
        wb.Props.Title = 'BSD Liabilities'

        XLSX.utils.book_append_sheet(wb, membersWS, this.committeeHeader.committeeCode)

        XLSX.writeFile(wb, this.currentYear + 'BSD Liabilities.xlsx')
      } catch (error) {
        this.error = error.response.data.error
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    closeThis (item) {
      this.emails = []
      this.showEmailForm = false
    },

    closeThisEval (item) {
      if (item) {
        this.snackbar.message = item
        this.snackbar.color = 'success'
        this.snackbar.show = true
      }

      this.evalItem = {}
      this.showEvalForm = false
    },

    close () {
      this.showSelect = false
      this.showEmailForm = false
      this.showEvalForm = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>



// WEBPACK FOOTER //
// src/components/bsd/List.vue